import React from 'react';
import { useUploadApi } from '../store/api/hooks/uploadApiHook';

// This component mounts the upload hook globally so that:
// 1. Background uploads continue across route changes.
// 2. Reconciliation + stale upload auto-completion runs even when not on the Upload page.
// 3. Toast notifications fire at the correct time on any page.
// It renders nothing visually.
const GlobalUploadWatcher: React.FC = () => {
  useUploadApi(); // Mounts interval + reconciliation logic
  return null;
};

export default GlobalUploadWatcher;
